<template>
  <div>
    <div v-if="three_rules.includes('确认添加')">
      <div class="title">设置会员</div>
      <div class="item-wrap">
        <div class="label">选择用户</div>
        <el-select
          v-model="user_uuid"
          filterable
          placeholder="请选择用户"
          class="select"
        >
          <el-option
            v-for="item in userList"
            :key="item.uuid"
            :label="item.user_name"
            :value="item.uuid"
          >
          </el-option>
        </el-select>
      </div>
      <div class="item-wrap">
        <div class="label">会员等级</div>
        <el-select
          v-model="class_uuid"
          filterable
          placeholder="请选择会员等级"
          class="select"
          @change="onClassChange"
        >
          <el-option
            v-for="item in classList"
            :key="item.uuid"
            :label="item.member_name"
            :value="item.uuid"
          >
          </el-option>
        </el-select>
        <div
          class="discount"
          v-if="discount"
        >{{this.discount}}折</div>
      </div>
      <div class="item-wrap">
        <div class="label">有效期</div>
        <el-select
          v-model="member_unit_uuid"
          filterable
          placeholder="请选择会员有效期"
          class="select"
        >
          <el-option
            v-for="item in specList"
            :key="item.uuid"
            :label="item.day"
            :value="item.uuid"
          >
          </el-option>
        </el-select>
      </div>
      <el-button
        type="primary"
        class="confirmBtn"
        @click="onAddClick"
      >确认添加</el-button>
    </div>
    <div class="header">
      <div class="left">
        <el-input
          v-model="keyword_search"
          placeholder="请输入手机号/昵称进行搜索"
          class="search-input"
          @input="handleSeacrInput"
          clearable
        ></el-input>
        <el-date-picker
          v-model="dateRange"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        <el-button
          type="primary"
          class="search-btn"
          @click="handleSearchClick"
        >搜索</el-button>
      </div>
      <el-button
        type="primary"
        @click="onExportClick"
        v-if="three_rules.includes('导出会员excel')"
      >导出excel</el-button>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="table-wrap"
    >
      <el-table-column
        prop="create_time"
        label="设置时间"
        align="center"
        width="160"
      >
      </el-table-column>
      <el-table-column
        prop="user_name"
        label="用户名称"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="user_mobile"
        label="绑定手机"
        align="center"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="member_name"
        label="设置VIP"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="VIP折扣"
        align="center"
        width="150"
      >
        <template slot-scope="scope">
          <div>{{scope.row.member_discount * 10}}折</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="member_time"
        label="有效期（天）"
        align="center"
        width="140"
      >
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
      >
        <template slot-scope="scope">
          <div class="remarks-wrap">
            <div :class="{remarks_box: true, yellow: scope.row.remarks_colour === '1', red: scope.row.remarks_colour === '2', green: scope.row.remarks_colour === '3'}">
            </div>
            <div>{{scope.row.remarks}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        align="center"
      >
        <template slot-scope="scope">
          <div class="operation-wrap">
            <span
              v-if="three_rules.includes('会员备注')"
              class="operation-item"
              @click="toRemarkClick(scope.row)"
            >备注</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <common-pagination
      :total="total"
      :page_size="page_size"
      @size-change="handelPagesizeChange"
      @page-change="handlePageChange"
    ></common-pagination>
    <common-dialog
      :title="dialogTitle"
      :dialogVisible="dialogVisible"
      @cancel="dialogVisible = false"
      @confirm="dialogConfirmClick"
      @dialog-close="dialogClose"
    >
      <div class="dialog-body-wrap">
        <div v-if="dialogType === 'remark'">
          <div class="dialog-remark-color-wrap">
            <span
              :class="{red: true, remarks_box: true, color_selected: order_row.remarks_colour === '2'}"
              @click="colorClick('2')"
            ></span>
            <span
              :class="{yellow: true, remarks_box: true, color_selected: order_row.remarks_colour === '1'}"
              @click="colorClick('1')"
            ></span>
            <span
              :class="{green: true, remarks_box: true, color_selected: order_row.remarks_colour === '3'}"
              @click="colorClick('3')"
            ></span>
          </div>
          <el-input
            type="textarea"
            placeholder="请输入文字"
            v-model="order_row.remarks"
            maxlength="500"
            show-word-limit
            :rows="10"
            class="remark-input"
          >
          </el-input>
        </div>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { userList } from "@/api/user";
import {
  getMemberList,
  getMemberUnit,
  getSetMemberList,
  addSetMemberList,
  editSetMember
} from "@/api/member-setting";
import CommonPagination from "@/components/CommonPagination";
import CommonDialog from "@/components/CommonDialog";
import utils from "@/jslibs/utils";

export default {
  name: "blank",
  data() {
    return {
      userList: [],
      user_uuid: "",
      class_uuid: "",
      discount: "",
      classList: [],
      specList: [],
      member_unit_uuid: "", //传空设为普通会员
      dateRange: [],
      keyword_search: "",
      page_size: 10,
      page_index: 1,
      total: 0,
      tableData: [],
      dialogTitle: "",
      dialogVisible: false,
      dialogType: "",
      order_row: {},
      three_rules: []
    };
  },
  components: {
    CommonPagination,
    CommonDialog
  },
  mounted() {
    this.getUserList();
    this._getMemberList();
    this._getSetMemberList();
    this.handleThreeRules();
  },
  computed: {
    ...mapState(["operationList"])
  },
  methods: {
    async getUserList() {
      let postData = {
        page_index: 1,
        page_size: 1000
      };
      const { data, status } = await userList(postData);
      if (status !== 200) return;
      this.userList = data.data;
    },
    async _getMemberList() {
      const { status, data } = await getMemberList();
      if (status === 200) {
        data.forEach(item => {
          item.member_discount = item.member_discount * 10;
        });
        this.classList = data;
      }
    },
    async _getMemberUnit() {
      const { status, data } = await getMemberUnit({
        member_uuid: this.class_uuid
      });
      if (status === 200) {
        data.forEach(item => {
          item.day = item.day + "天";
        });
        this.specList = data;
      }
    },
    async _getSetMemberList() {
      const dateRange = this.dateRange;
      const start_time = dateRange && dateRange.length ? dateRange[0] : "";
      const end_time = dateRange && dateRange.length ? dateRange[1] : "";
      const postData = {
        page_index: this.page_index,
        page_size: this.page_size,
        keyword_search: this.keyword_search,
        start_time,
        end_time
      };
      const { status, data } = await getSetMemberList(postData);
      if (status === 200) {
        this.tableData = data.data;
        console.log(data, "dddd");
      }
    },
    onClassChange(e) {
      this.discount = this.classList.filter(
        item => item.uuid === e
      )[0].member_discount;
      this._getMemberUnit();
    },
    onDateChange() {},
    async onExportClick() {
      let loading = this.$loading({
        lock: true,
        text: "正在努力下载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const dateRange = this.dateRange;
      const start_time = dateRange && dateRange.length ? dateRange[0] : "";
      const end_time = dateRange && dateRange.length ? dateRange[1] : "";
      const postData = {
        keyword_search: this.keyword_search,
        start_time,
        end_time
      };
      const res = await utils.downloadFile("/v1/cms/SetMemberExcel", postData);
      utils.downloadBlobFile(res.data, `VIP设置列表.xlsx`);
      loading.close();
    },
    async onAddClick() {
      if (!this.user_uuid) {
        this.$message("请选择用户");
        return;
      }
      const postData = {
        user_uuid: this.user_uuid,
        member_unit_uuid: this.member_unit_uuid
      };
      const { status } = await addSetMemberList(postData);
      if (status === 200) {
        this.$message({
          type: "success",
          message: "添加成功"
        });
        this._getSetMemberList();
      }
    },
    handleSeacrInput(val) {
      //当inputValu为空时重新请求数据
      if (!val) this._getSetMemberList();
    },
    handleSearchClick() {
      this._getSetMemberList();
    },
    handlePageChange(page) {
      this.page_index = page;
    },
    handelPagesizeChange(size) {
      this.page_size = size;
    },
    toRemarkClick(row) {
      this.order_row = JSON.parse(JSON.stringify(row));
      this.dialogType = "remark";
      this.dialogTitle = "备注信息";
      this.dialogVisible = true;
      console.log(this.order_row, "rrr");
    },
    colorClick(remarks_colour) {
      this.$set(this.order_row, "remarks_colour", remarks_colour);
    },
    async dialogConfirmClick() {
      const { remarks, remarks_colour } = this.order_row;
      if (!remarks_colour || !remarks) {
        this.$message("请选择备注颜色和输入备注内容");
        return;
      }
      let postData = {
        remarks,
        remarks_colour
      };
      const { status } = await editSetMember(postData, this.order_row.id);
      if (status === 200) this.dialogVisible = false;
    },
    dialogClose() {
      this.dialogVisible = false;
      this._getSetMemberList();
    },
    handleThreeRules() {
      //处理三级权限
      console.log(this.operationList, "operations");
      this.operationList.forEach(item => {
        if (item.name === "会员设置") {
          this.three_rules = item.operations.map(item => item.menu_name);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/styles/mixins.less";

.title {
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: 500;
}
.item-wrap {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .label {
    width: 100px;
    margin-right: 30px;
  }
  .discount {
    margin-left: 20px;
  }
}
.confirmBtn {
  display: block;
  margin: 30px auto 50px;
}
.header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  .left {
    display: flex;
    .search-input {
      width: 300px;
      margin-right: 20px;
    }
    .search-btn {
      margin-left: 20px;
    }
  }
}
.remarks_box {
  display: inline-block;
  width: 40px;
  height: 40px;
}
.yellow {
  background: yellow;
}
.red {
  background: red;
}
.green {
  background: green;
}
.table-wrap {
  .remarks-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .operation-wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    color: @color-text;
    .operation-item {
      cursor: pointer;
      margin-right: 5px;
    }
  }
}
.dialog-body-wrap {
  text-align: center;
  .color_selected {
    border: 2px solid #000;
  }
  .dialog-remark-color-wrap {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }
}
</style>
